import { css } from 'styled-components';

export const paddingVertical = (amount: number) => css`
  padding-top: ${amount}px;
  padding-bottom: ${amount}px;
`;

export const paddingHorizontal = (amount: number) => css`
  padding-left: ${amount}px;
  padding-right: ${amount}px;
`;

export const multiple = (value: string, ...properties: string[]) => (
  properties.map(prop => `${prop}: ${value};`).join(' ')
);

export const multiplePixel = (value: number, ...properties: string[]) => multiple(`${value}px`, ...properties);

export const pixelProps = <P>(propName: string) => (props: P) => css`${propName}: ${props[propName]}px;`;



// WEBPACK FOOTER //
// src/app/src/styles/utils.ts